import React__default from 'react';
import { getDefaultRadixPortalContainer } from '@fabric-app/compat';
import { useClientLayoutEffect } from '@fabric-app/hooks/useClientLayoutEffect';

const config = {
  childList: true,
  subtree: false
};
const useIsAnyRadixModalOpenCount = () => {
  const [radixModalsCount, setRadixModalsCount] = React__default.useState(0);
  useClientLayoutEffect(() => {
    const observedTarget = getDefaultRadixPortalContainer() ?? document.body;
    if (!observedTarget) return;
    const observer = new MutationObserver((mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          setRadixModalsCount(observedTarget.querySelectorAll(`[role="dialog"][data-state="open"]`).length);
        }
      }
    });
    observer.observe(getDefaultRadixPortalContainer() ?? document.body, config);
    return () => {
      observer.disconnect();
    };
  }, []);
  return radixModalsCount;
};

export { useIsAnyRadixModalOpenCount };
//# sourceMappingURL=useIsAnyRadixModalOpened.js.map
